export const REQUEST_CURRENCY_DATA = "REQUEST_CURRENCY_DATA";
export const RECEIVE_CURRENCY_DATA = "RECEIVE_CURRENCY_DATA";
export const REQUEST_CURRENCY_DATA_FAILED = "REQUEST_CURRENCY_DATA_FAILED";

export const receiveData = (data) => ({ type: RECEIVE_CURRENCY_DATA, payload: data });
export const requestFailed = (error) => ({ type: REQUEST_CURRENCY_DATA_FAILED, payload: error });
